import * as React from 'react'

import {useDerivedState} from '../../../../../../hocs/withDerivedState'
import type {BuildId} from '../../../../../../types'
import BuildsWrapped, {BuildsWrappedPlaceholder} from '../../../../../common/Builds/Builds.wrapped'
import {useVisibility} from '../../../../../common/Visible/Visible.hooks'

import styles from './ChangeBuildTypeDetails.css'

type Props = {
  buildIds: readonly BuildId[]
  nested?: boolean
}

function ChangeBuildTypeDetails({buildIds, nested}: Props) {
  const ref = React.useRef<HTMLDivElement>(null)
  const isVisible = useVisibility(ref)
  const wasVisible = useDerivedState(false, state => state || isVisible)
  return buildIds.length > 0 ? (
    <>
      <div ref={ref} className={styles.visibilityDetector} />
      {wasVisible ? (
        <BuildsWrapped nested={nested} hasParentGrid buildIds={buildIds} />
      ) : (
        <BuildsWrappedPlaceholder hasParentGrid />
      )}
    </>
  ) : null
}

export default ChangeBuildTypeDetails
